var step = 0;
var selectLocation = ''
var selectlocationDescription = ''
var selectService = ''
var appointmentType = ''
document.addEventListener('DOMContentLoaded', function () {
    let formContent;
    const locationSelectButtons = document.querySelectorAll('.location_card-select-button');
    const cardBlockList = document.querySelectorAll('.card-block');
    const locationSection = document.querySelector('.location_block');
    const serviceSection = document.querySelector('.service');
    const tabListItems = document.querySelectorAll('.tab-list_item');
    const tabListItems_mobile = document.querySelectorAll('.tab-progress-bar_item');
    const backButtons = document.querySelectorAll('.back-button');
    const backButtonTexts = document.querySelectorAll('.back-button .back-button_text');
    const tabList = document.querySelector('.tab-list')
    const tabListMobile = document.querySelector('.tab-list_mobile')
    var mobileHeader = document.querySelector('.tab-progress_text')
    var tabSubtitleTitle = document.querySelectorAll('.tab-list-item_text .tab_subtitle')
    var tabCompleteSubtitleLocation = document.querySelectorAll('.tab_complete_subtitle_location')
    var serviceSelectButtons = document.querySelectorAll('.service_card-select-button')
    var triangleLeft = document.querySelectorAll('.triangle-left')
    var stops = document.querySelectorAll('.triangle-left stop')
    var divideSvg = document.querySelectorAll('.tab-list-item_divide svg')
    var rect = document.querySelectorAll('.tab-list-item_divide svg rect')
    var divides = document.querySelectorAll('.tab-list-item_divide')
    var tab_title =  document.querySelectorAll('.tab-list_item_left .tab_title')

    const confirmationDiv = document.querySelector('.cust-step-three__content')

    if (window.innerWidth > 768) {
        // tabList.style.display = 'flex'
        // tabListMobile.style.display = 'none'

        if (tabListItems.length > 0) {
            tabListItems[0].classList.add('active');
            stops[0].setAttribute('stop-color', '#fff');
            divideSvg[0].style.height = '103px'
        }
    } else {
        // tabList.style.display = 'none'
        // tabListMobile.style.display = 'block'

        if (tabListItems_mobile.length > 0) {
            tabListItems_mobile[0].classList.add('activeMobile');
            mobileHeader.innerText = `${tabListItems_mobile[0].getAttribute('data-tab-title').toUpperCase()} ${tabListItems_mobile[0].getAttribute('data-tab-subtitle')}`
        }
    }


    backButtons.forEach(backButton => {
      backButton.style.display = 'none'
    })

    if (cardBlockList.length > 1) {
        cardBlockList.forEach((item, index) => {
            if (index == 0) return
            item.style.display = 'none';
        })
    }

    locationSelectButtons.forEach(button => {
        button.addEventListener('click', function () {
            if(this.closest('.service-item')){
                var serviceCardTitle = this.closest('.service-item').querySelector('.service-title').textContent;
                if (serviceCardTitle.includes('Phone Consultation') && window.openGemstoneContactModal) {
                    if(!this.dataset.formContent){
                        window.openGemstoneContactModal(this);
                        return;
                    }else{
                        formContent = JSON.parse(this.dataset.formContent);
                        this.dataset.formContent = ""
                        ++step;
                        const locationCard = this.closest('.location_card-item');
                        if (locationSection) {
                            locationSection.style.display = 'none';
                        }

                        if (serviceSection) {
                            serviceSection.style.display = 'block';
                            backButtons.forEach(backButton => {
                            backButton.style.display = 'flex'
                            })
                            backButtonTexts.forEach(backButtonText => {
                            backButtonText.innerText = 'Back to location'
                            })
                        }
                        serviceSelectButtons[0].click();
                        return;
                    }  
                }
            }
            ++step;
            const locationCard = this.closest('.location_card-item');
            const locationTitle = locationCard.querySelector('.location_card-title').textContent;
            selectLocation = locationTitle.toUpperCase();
            selectlocationDescription = locationCard.querySelector('.location_card-title').getAttribute('data-location-link') || '';
            if (locationSection) {
                locationSection.style.display = 'none';
            }

            if (serviceSection) {
                serviceSection.style.display = 'block';
                backButtons.forEach(backButton => {
                  backButton.style.display = 'flex'
                })
                backButtonTexts.forEach(backButtonText => {
                  backButtonText.innerText = 'Back to location'
                })
            }

            if (window.innerWidth > 768) {
                tabListItems.forEach((tab, index) => {
                    tab.classList.remove('active');
                    if (index === 0) {
                        var divide = document.querySelectorAll('.tab-list-item_divide')[0]
                        divide.classList.add('divideActive')
                        tabSubtitleTitle[index].style.display = 'none'
                        tab_title[0].innerText = `Chosen Location`
                        tabCompleteSubtitleLocation[index].innerText = locationTitle
                        rect[index].style.fill = '#fff'
                        stops[0].setAttribute('stop-color', '#f9f9f9');
                        stops[1].setAttribute('stop-color', '#fff');
                        divideSvg[0].style.height = '101px'
                        divideSvg[1].style.height = '103px'
                    }
                    if (index === 1) tab.classList.add('active'); // 第二个tab
                });
                tabList.style['margin-top'] = '48px'
                var index = step - 1
                tabListItems[index].classList.add('complete')
            } else {
                tabListItems_mobile.forEach((tab, index) => {
                    tab.classList.remove('activeMobile');
                    if (index === step) {
                        tab.classList.add('activeMobile');
                        mobileHeader.innerText = `${tabListItems_mobile[step].getAttribute('data-tab-title').toUpperCase()} ${tabListItems_mobile[step].getAttribute('data-tab-subtitle')}`
                    }
                });
                var index = step - 1
                tabListItems_mobile[index].classList.add('complete')
            }
            if(window.innerWidth < 768){
                const tabSection = document.querySelector('.cust-book-tab-section');
                const targetPosition = tabSection.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                  top: targetPosition,
                  behavior: 'smooth'
                });
              }
        });
    });

    const urlParams = new URLSearchParams(window.location.search);
    const location = urlParams.get('location'); 
    if(location && document.querySelector('.location_card-select-button[data-location="'+location+'"]')){
      document.querySelector('.location_card-select-button[data-location="'+location+'"]').click()
    }

    document.querySelectorAll('.view-info_burron').forEach(button => {
        button.addEventListener('click', function () {
            const associatedId = this.getAttribute('data-associated-id');
            var viewInfoSections = document.querySelectorAll('.cust-view-info-section')
            var viewInfomodal = document.querySelector('.cust-view-info-modal')
            var body = document.querySelector('.template-page')
            var podiumWebsite = document.querySelector('#podium-website-widget')
            viewInfoSections.forEach(el => {
                if (el.getAttribute('data-viewinfo-associated-id') == associatedId) {
                    el.style.display = 'block'
                }
            })
            viewInfomodal.style.display = 'flex'
            if(body){
              body.style.overflow = 'hidden'
            }
            podiumWebsite.style.display = 'none'
        });
    });

    document.querySelectorAll('.showroom-btn').forEach(button => {
        button.addEventListener('click', function () {
            confirmationDiv.style.display = "none";
            step = 0; 
            
            cardBlockList.forEach(i => i.style.display = 'none')
            cardBlockList[step].style.display = 'block';
            
            const iframe = document.querySelector('.card-blocks iframe');
            if (iframe) {
                iframe.remove();
            }
            
            if (window.innerWidth > 768) {
                tabListItems.forEach((tab, index) => {
                    tab.classList.remove('active');
                    tab.classList.remove('complete');
                    tabSubtitleTitle[index].style.display = 'block';
                    tabCompleteSubtitleLocation[index].innerText = '';
                    if (index === 0) {
                        tab.classList.add('active');
                    }
                });
                
                if (tab_title.length > 2) {
                    tab_title[2].innerText = `Choose a`;
                }
                
                tabList.style['margin-top'] = '60px';
                stops[0].setAttribute('stop-color', '#fff');
                stops[1].setAttribute('stop-color', '#f9f9f9');
                stops[2].setAttribute('stop-color', '#f9f9f9');
                rect[0].style.fill = '#f9f9f9';
                rect[1].style.fill = '#f9f9f9';
                rect[2].style.fill = '#f9f9f9';
                divides[2].style.display = 'none';
                divides[2].style.backgroundColor = '#f9f9f9';
                divideSvg[0].style.height = '103px';
                divideSvg[1].style.height = '101px';
                divideSvg[2].style.height = '101px';
                tabList.style.borderColor = '#e8e8e1';
            } else {
                // 更新移动端的标签页状态，使其与电脑端一致
                // 1和3也要变成对勾
                tabListItems_mobile.forEach((tab, index) => {
                    tab.classList.remove('activeMobile');
                    tab.classList.remove('complete');
                    if (index === 0) {
                        tab.classList.add('activeMobile');
                    } else if (index === 1 || index === 2) {
                        tab.classList.add('complete');
                    }
                });
                // 不需要小标题
                mobileHeader.innerText = `${tabListItems_mobile[step].getAttribute('data-tab-title').toUpperCase()}`;
            }
            
            backButtons.forEach(item => {
                item.style.display = 'none';
            });
            
            if (window.innerWidth < 768) {
                const tabSection = document.querySelector('.cust-book-tab-section');
                const targetPosition = tabSection.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });




    serviceSelectButtons.forEach(button => {
        button.addEventListener('click', function () {
            ++step;
            const serviceCard = this.closest('.service_card-item');
            const serviceTitle = serviceCard.querySelector('.service_card-title').textContent;
            const appointmentType = this.getAttribute('data-appointment-type')
            this.selectService = serviceTitle

            if (serviceSection) {
                serviceSection.style.display = 'none';
            }

            if (window.innerWidth > 768) {
                tabListItems.forEach((tab, index) => {
                    tab.classList.remove('active');
                    document.querySelectorAll('.tab-list-item_divide')[0].classList.remove('divideActive')
                    if (index === 1) {
                        var divide = document.querySelectorAll('.tab-list-item_divide')[1]
                        divide.classList.add('divideActive')
                        tabSubtitleTitle[index].style.display = 'none'
                        tabCompleteSubtitleLocation[index].innerText = serviceTitle
                        tab_title[1].innerText = `Chosen Service`
                        rect[0].style.fill = '#f9f9f9'
                        rect[1].style.fill = '#fff'
                        rect[2].style.fill = '#fff'
                        stops[0].setAttribute('stop-color', '#f9f9f9');
                        stops[1].setAttribute('stop-color', '#f9f9f9');
                        stops[2].setAttribute('stop-color', '#fff');
                        divides[2].style.display = 'block'
                        divides[2].style.backgroundColor = '#fff';
                        divideSvg[1].style.height = '101px'
                        divideSvg[2].style.height = '103px'

                    }
                    if (index === 2) tab.classList.add('active');
                    tabList.style.borderColor = '#fff'
                });
                var index = step - 1
                tabListItems[index].classList.add('complete')
            } else {
                tabListItems_mobile.forEach((tab, index) => {
                    tab.classList.remove('activeMobile');
                    if (index === step) {
                        tab.classList.add('activeMobile');
                        mobileHeader.innerText = `${tabListItems_mobile[step].getAttribute('data-tab-title').toUpperCase()} ${tabListItems_mobile[step].getAttribute('data-tab-subtitle')}`
                    }
                });
                var index = step - 1
                tabListItems_mobile[index].classList.add('complete')
            }
            if(window.innerWidth < 768){
              const tabSection = document.querySelector('.cust-book-tab-section');
              const targetPosition = tabSection.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            }
            if(formContent){
                const dayValue = formContent.preferred_day || 'Not selected';
                const timeValue = formContent.preferred_time || 'Not selected';
                
                const dayElement = document.getElementById('confirmation-day');
                const timeElement = document.getElementById('confirmation-time');
                
                if (dayElement) {
                    dayElement.textContent = dayValue;
                }
                if (timeElement) {
                    timeElement.textContent = timeValue;
                }
                                
                if (window.innerWidth > 768) {
                    tab_title[2].innerText = `Chosen DATE/TIME`;
                    tabCompleteSubtitleLocation[2].innerText = `${dayValue} - ${timeValue}`;
                    tabSubtitleTitle[2].style.display = 'none';
                    tabListItems[2].classList.add('complete');
                }
                confirmationDiv.style.display = "block";
            }else{
                const iframeHeight =  document.querySelector('.iframe_height').dataset.iframeHeight;
                const iframeHeight_mobile =  document.querySelector('.iframe_height_mobile').dataset.iframeHeight;
                const iframe = document.createElement('iframe');
                iframe.src = `https://app.acuityscheduling.com/schedule.php?owner=17377215&appointmentType=${appointmentType}&${selectlocationDescription}&ref=embedded_csp`;
                iframe.title = "Schedule Appointment";
                iframe.width = "100%";
                iframe.height = iframeHeight;
            if(window.innerWidth < 768){
                iframe.height = iframeHeight_mobile;
            }
                // iframe.scrolling = 'no';
                const cardBlocks = document.querySelector('.card-blocks');
                if (cardBlocks) {
                    cardBlocks.insertAdjacentElement('afterbegin', iframe);
                }
            }

            backButtonTexts.forEach(backButtonText => {
              backButtonText.innerText = 'Back to Service'
            })

        })
    })

    backButtons.forEach(backButton => {
        backButton.addEventListener('click', function () {
            confirmationDiv.style.display = "none";
            --step;
            cardBlockList.forEach(i => i.style.display = 'none')
            cardBlockList[step].style.display = 'block';
            const iframe = document.querySelector('.card-blocks iframe');
            if (iframe) {
                iframe.remove();
            }
            if (window.innerWidth > 768) {
                tabListItems[step].classList.remove('complete')
                tabCompleteSubtitleLocation[step].innerText = ''
                tabSubtitleTitle[step].style.display = 'block'
                tabListItems.forEach((tab, index) => {
                    tab.classList.remove('active');
                    if (index === step) {
                        var divide = document.querySelectorAll('.tab-list-item_divide')[step]
                        divide.classList.remove('divideActive')
                        tab.classList.add('active');
                    }
                    if (step == 1) {
                        var divide = document.querySelectorAll('.tab-list-item_divide')[0]
                        divide.classList.add('divideActive')
                    }
                });
                if (step == 0) {
                  tab_title[0].innerText = `Choose a`
                    tabList.style['margin-top'] = '60px'
                    stops[0].setAttribute('stop-color', '#fff');
                    stops[1].setAttribute('stop-color', '#f9f9f9');
                    rect[0].style.fill = '#f9f9f9'
                    divideSvg[0].style.height = '103px'
                    divideSvg[1].style.height = '101px'
                }
                if (step == 1) {
                  tab_title[1].innerText = `Choose a`
                  if (tab_title.length > 2) {
                    tab_title[2].innerText = `Choose a`
                    tabCompleteSubtitleLocation[2].innerText = ''
                    tabSubtitleTitle[2].style.display = 'block'
                    tabListItems[2].classList.remove('complete')
                  }
                  divides[2].style.display = 'none'
                  divides[2].style.backgroundColor = '#f9f9f9';
                  stops[2].setAttribute('stop-color', '#f9f9f9');
                  stops[1].setAttribute('stop-color', '#fff');
                  stops[0].setAttribute('stop-color', '#f9f9f9');
                  rect[0].style.fill = '#fff'
                  rect[1].style.fill = '#f9f9f9'
                  tabList.style.borderColor = '#e8e8e1'
                  divideSvg[0].style.height = '101px'
                  divideSvg[1].style.height = '103px'
                
                  backButtonTexts.forEach(backButtonText => {
                    backButtonText.innerText = 'Back to Location'
                  })
                }
            } else {
                tabListItems_mobile[step].classList.remove('complete')
                tabListItems_mobile.forEach((tab, index) => {
                    tab.classList.remove('activeMobile');
                    if (index === step) {
                        tab.classList.add('activeMobile');
                    }
                });
                mobileHeader.innerText = `${tabListItems_mobile[step].getAttribute('data-tab-title').toUpperCase()} ${tabListItems_mobile[step].getAttribute('data-tab-subtitle')}`
            }
            if(window.innerWidth < 768){
              const tabSection = document.querySelector('.cust-book-tab-section');
              const targetPosition = tabSection.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            }
            if (step == 0) {
              backButtons.forEach(item => {
                item.style.display = 'none'
              });
            }

        });
      })
});